import { CIcon } from '~/icons/types'

export const ciBicycles: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M19.265 10.1c-.452.007-.9.08-1.332.215l-.608-1.707v-.015l-.3-.844c0-.009-.01-.015-.013-.024l-.96-2.691v-.008l-.005-.015c0-.014-.016-.024-.022-.037a.508.508 0 0 0-.076-.127c-.01-.011-.023-.018-.033-.028a.508.508 0 0 0-.122-.089c-.008 0-.016 0-.024-.008a.507.507 0 0 0-.14-.044l-2.296-.248a.5.5 0 1 0-.107.994l1.979.213.644 1.81-6.52.3-.288-.663h.712a.5.5 0 0 0 0-1l-2.561-.005a.5.5 0 1 0 0 1h.764v.01l.35.8a.487.487 0 0 0-.13.127L6.65 10.51a4.74 4.74 0 1 0 2.773 4.828h1.17a1.406 1.406 0 0 0 2.518-1.222l3.565-4.353.332.933a4.7 4.7 0 1 0 2.257-.6v.004ZM8.77 8.965l2.015 4.628a1.409 1.409 0 0 0-.387.745h-.976a4.715 4.715 0 0 0-1.91-3.322L8.77 8.965Zm-.348 5.373H5.477l1.51-2.465a3.718 3.718 0 0 1 1.436 2.465Zm-3.688 4.236a3.738 3.738 0 1 1 0-7.476 3.7 3.7 0 0 1 1.387.274l-1.965 3.2a.5.5 0 0 0 .427.762h3.839a3.732 3.732 0 0 1-3.688 3.24Zm7.713-5.225a1.39 1.39 0 0 0-.662-.172c-.03 0-.058.007-.087.008L9.759 8.73l6.442-.3.083.232-3.836 4.687Zm6.817 5.225a3.727 3.727 0 0 1-1.92-6.929l1.2 3.362a.5.5 0 1 0 .942-.336l-1.218-3.42a3.703 3.703 0 0 1 1-.153 3.738 3.738 0 1 1 0 7.476h-.004Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'bicycles',
  type: 'thin'
}
